export default __webpack_public_path__ + "static/media/mongodb-ar21.b508609b.svg";